import { Wrench } from "lucide-react";
import SEO from "@/components/SEO";

const MaintenancePage = () => (
  <div
    dir="rtl"
    className="min-h-screen flex items-center justify-center bg-dark text-dark-foreground px-6"
  >
    <SEO title="האתר בשיפוצים" description="האתר בשיפוצים, מיד נחזור לפעילות" path="/" noindex />
    <div className="text-center max-w-xl">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 text-primary mb-6">
        <Wrench size={40} />
      </div>
      <h1 className="text-3xl md:text-4xl font-bold mb-4">
        מצטערים, אנחנו משפצים את האתר
      </h1>
      <p className="text-lg text-dark-foreground/70">מיד נחזור לפעילות</p>
    </div>
  </div>
);

export default MaintenancePage;
